import { render, staticRenderFns } from "./relationField.vue?vue&type=template&id=db88091c&"
import script from "./relationField.vue?vue&type=script&lang=js&"
export * from "./relationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports